import { Button, Card, PasswordInput, Stack, Text, TextInput, Title } from '@mantine/core';
import { useForm } from '@mantine/form';
import { notifications } from '@mantine/notifications';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { api, apiErrorMessage } from '../api';
import { useAuth } from '../providers/auth-context';

export const LoginPage = () => {
    const { t } = useTranslation();
    const { refresh } = useAuth();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const form = useForm({
        initialValues: { email: '', password: '' },
        validate: {
            email: (v) => (/^\S+@\S+\.\S+$/.test(v) ? null : t('pages.login.invalidEmail')),
            password: (v) => (v ? null : t('pages.login.passwordRequired')),
        },
    });

    const submit = async (values: typeof form.values) => {
        setLoading(true);

        try {
            await api.admins.login({ data: values });
            await refresh();
            navigate('/');
        } catch (error) {
            notifications.show({ color: 'red', message: apiErrorMessage(error) });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card padding='xl' shadow='sm'>
            <form onSubmit={form.onSubmit(submit)}>
                <Stack gap='md'>
                    <div>
                        <Title order={2}>{t('pages.login.title')}</Title>
                        <Text c='dimmed' size='sm' mt={4}>
                            {t('pages.login.subtitle')}
                        </Text>
                    </div>

                    <TextInput
                        label={t('pages.login.email')}
                        placeholder={t('pages.login.emailPlaceholder')}
                        autoComplete='email'
                        {...form.getInputProps('email')}
                    />

                    <PasswordInput
                        label={t('pages.login.password')}
                        autoComplete='current-password'
                        {...form.getInputProps('password')}
                    />

                    <Button type='submit' loading={loading} fullWidth>
                        {t('pages.login.submit')}
                    </Button>
                </Stack>
            </form>
        </Card>
    );
};
